const notification = {
  markRead: 'Đánh dấu đã đọc',
  markReadAll: 'Đánh dấu tất cả đã đọc',
  notification: 'Thông báo',
  viewAllNotification: 'Xem tất cả thông báo',
  error: 'Xảy ra lỗi',
  reportCreated: 'Hoàn thành tạo báo cáo',
  scanDone: 'Hoàn thành quét',
  scanFailed: 'Quét thất bại',
  scanAborted: 'Đã hủy bỏ quét',
  noData: 'Danh sách trống',
  list: 'Danh sách thông báo'
};

export default notification;
